import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";

const SimpleLineChartGraph = ({ data, activeTab }) => {
    const chartData = {
        Semana: [
            { name: "Lun", uv: 4000, pv: 2400, amt: 2400 },
            { name: "Mar", uv: 3000, pv: 1398, amt: 2210 },
            { name: "Mié", uv: 2000, pv: 9800, amt: 2290 },
            { name: "Jue", uv: 2780, pv: 3908, amt: 2000 },
            { name: "Vie", uv: 1890, pv: 4800, amt: 2181 },
            { name: "Sáb", uv: 2390, pv: 3800, amt: 2500 },
        ],
        Mes: [
            { name: "Sem 1", uv: 15000, pv: 12000, amt: 11000 },
            { name: "Sem 2", uv: 18000, pv: 14000, amt: 13000 },
            { name: "Sem 3", uv: 16000, pv: 13500, amt: 12500 },
            { name: "Sem 4", uv: 20000, pv: 16000, amt: 15000 },
        ],
        Año: [
            { name: "Ene", uv: 40000, pv: 24000, amt: 24000 },
            { name: "Feb", uv: 30000, pv: 13980, amt: 22100 },
            { name: "Mar", uv: 20000, pv: 98000, amt: 22900 },
            { name: "Abr", uv: 27800, pv: 39080, amt: 20000 },
            { name: "May", uv: 18900, pv: 48000, amt: 21810 },
            { name: "Jun", uv: 23900, pv: 38000, amt: 25000 },
        ],
    };

    const LINE_COLORS = ["#0b6775", "#5599a3", "#ff7300", "#82ca9d", "#ffc658"];

     const formatLegendName = (key) => {
        const result = key.replace(/([A-Z])/g, " $1");
        return result.charAt(0).toUpperCase() + result.slice(1);
    };

    // 3. Selecciona los datos a mostrar según la pestaña activa
    const displayData = data?.[activeTab] || chartData[activeTab] || [];

    // 4. Detecta automáticamente las claves de datos a dibujar (todas menos 'name')
    const lineKeys =
        displayData.length > 0
            ? Object.keys(displayData[0]).filter((key) => key !== "name")
            : [];

    return (
        <div style={{ width: "100%", height: "100%", position: "relative" }} >
            <ResponsiveContainer width="100%" height="100%">
                <LineChart data={displayData} margin={{ top: 5, right: 10, left: 5, bottom: 5, }} >
                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                    <XAxis dataKey="name" tick={{ fontSize: 11, fill: "#666" }} axisLine={false} tickLine={false} />
                    <YAxis tick={{ fontSize: 11, fill: "#666" }} axisLine={false} tickLine={false} width={44} />
                    <Tooltip contentStyle={{ backgroundColor: "#fff", border: "none", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", }} />
                    <Legend wrapperStyle={{ fontSize: "14px", color: "#666", paddingTop: "10px", }} />

                    {/* 5. Mapea las claves detectadas para renderizar cada línea dinámicamente */}
                    {lineKeys.map((key, index) => (
                        <Line
                            key={key}
                            type="monotone"
                            dataKey={key}
                            name={formatLegendName(key)}
                            stroke={LINE_COLORS[index % LINE_COLORS.length]}
                            activeDot={{ r: 6 }}
                            strokeWidth={2}
                            dot={{ r: 3 }}
                        />
                    ))}
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default SimpleLineChartGraph;